import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/generals/logo'
import { siteConfig } from '@/constants/site'

const COLUMNS = [
    {
        title: 'Attend',
        links: [
            { href: '/events', label: 'Browse events' },
            { href: '/tickets', label: 'Find my tickets' },
            { href: '/events?price=free', label: 'Free events' }
        ]
    },
    {
        title: 'Organize',
        links: [
            { href: '/signup', label: 'Start selling' },
            { href: '/sell', label: 'Features' },
            { href: '/sell#pricing', label: 'Pricing' },
            { href: '/login', label: 'Organizer login' }
        ]
    },
    {
        title: 'Company',
        links: [
            { href: '/contact', label: 'Contact us' },
            { href: '/privacy', label: 'Privacy policy' }
        ]
    }
]

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='bg-ink text-ink-foreground'>
            <div className='mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-[1.4fr_2fr] lg:px-8'>
                <div className='flex max-w-sm flex-col gap-4'>
                    <Logo tone='dark' />

                    <p className='text-sm leading-relaxed text-ink-muted'>
                        The all-in-one ticketing platform for concerts, conferences, classes and everything in between.
                    </p>
                </div>

                <div className='grid grid-cols-2 gap-10 sm:grid-cols-3'>
                    {COLUMNS.map(column => (
                        <div key={column.title} className='flex flex-col gap-4'>
                            <h2 className='font-sans text-xs font-semibold uppercase tracking-[0.16em] text-ink-muted'>
                                {column.title}
                            </h2>

                            <ul className='flex flex-col gap-3'>
                                {column.links.map(link => (
                                    <li key={link.href}>
                                        <Link href={link.href} className='text-sm text-ink-foreground/90 transition-colors hover:text-accent'>
                                            {link.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            <div className='border-t border-white/10'>
                <div className='mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 text-xs text-ink-muted sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8'>
                    <p>
                        &copy; <span suppressHydrationWarning>{new Date().getFullYear()}</span> {siteConfig.name}. All rights reserved.
                    </p>

                    <p>Payments are processed securely by Stripe.</p>
                </div>
            </div>
        </footer>
    )
}
